import { Injectable } from '@angular/core';
import { IndexClient } from '../models/client';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

interface IAppointment {
  external_id?: number|string
  location_id?: number|string
  internal_status?: string
  appointment_id?: number|string
  no_show?: boolean
}

@Injectable({
  providedIn: 'root'
})
export class MindbodyAppointmentsService {

  constructor(private http: HttpClient) { }

  update(appointment: IAppointment): Observable<any> {
    const url = `${environment.baseUrl}/locations/${appointment.location_id}/mindbody_appointments/${appointment.external_id}`
    return this.http.put<any>(url, appointment)
  }

  getNoShows(appointment: IAppointment): Observable<any[]> {
    const url = `${environment.baseUrl}/locations/${appointment.location_id}/mindbody_appointments/no_show_history?appointment_id=${appointment.external_id}`
    return this.http.get<any[]>(url)
  }

  sendNoShowEmail(appointment: IAppointment, emailOption: string): Observable<any> {
    const url = `${environment.baseUrl}/locations/${appointment.location_id}/mindbody_appointments/send_no_show_email_to_client?email_type=${emailOption}`
    return this.http.post<any>(url, appointment)
  }
}
